import { render } from "./TemplateElementsPreviewImage.vue?vue&type=template&id=bdd6c470&scoped=true"
import script from "./TemplateElementsPreviewImage.vue?vue&type=script&lang=ts"
export * from "./TemplateElementsPreviewImage.vue?vue&type=script&lang=ts"

import "./TemplateElementsPreviewImage.vue?vue&type=style&index=0&id=bdd6c470&lang=scss&scoped=true"
import "./TemplateElementsPreviewImage.vue?vue&type=style&index=1&id=bdd6c470&lang=scss"
script.render = render
script.__scopeId = "data-v-bdd6c470"

export default script